/**
 * @generated SignedSource<<c79a001bccae81783ce55db5c3c3424f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell";
};
export type OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$key = {
  readonly " $data"?: OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraTimeTrackingField"
};

(node as any).hash = "0f9568b7761de31d0e404aa0db105650";

export default node;
